import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { MapSection, setSection } from "../../services/reducers/map";
import { initializeMap } from "../../services/actions/map";
import styles from "./multiple-plot-list-page.module.scss";
import { MapLeftPanel } from "../../shared/map-left-panel/map-left-panel";
import MapControls from "../../components/map-controls/map-controls";
import MultiplePlotList from "../../components/features/multiple-plot-list/multiple-plot-list";
import { MapWrapper } from "../../shared/map-wrapper/map-wrapper";
import MultiplePlotListLegend from "../../components/features/multiple-plot-list/multiple-plot-list-legend/multiple-plot-list-legend";

export const MultiplePlotListPage = () => {
  const [leftPanelOpened, setLeftPanelOpened] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const [panelWidth, setPanelWidth] = useState<number>(0);

  useEffect(() => {
    dispatch(setSection(MapSection.multiplePlot));
    dispatch(initializeMap({ section: MapSection.multiplePlot, mode: "2d" }));
    return () => {
      dispatch(initializeMap({ section: MapSection.none, mode: "2d" }));
    };
  }, []);

  return (
    <div className={styles.multiplePlotListPage}>
      <MapLeftPanel
        onWidthChange={setPanelWidth}
        leftPanelOpened={leftPanelOpened}
        closeLeftPanel={setLeftPanelOpened}
      >
        <MultiplePlotList />
      </MapLeftPanel>
      <MapWrapper
        leftPanelOpened={leftPanelOpened}
        legend={<MultiplePlotListLegend />}
        panelWidth={panelWidth}
        containerId={`${MapSection.multiplePlot}MapContainer`}
      />
      <MapControls />
    </div>
  );
};
